export const config = {
  "tribes": ["OSFM", "CEP", "KRM"],
  "solutions": {
    "OSFM": {
      "Dynamic Maintenance Planning (DMP)": "DMP",
      "Service Tools": "ST"
    },
    "CEP": {
      "AWS IoT Core": "IoT",
      "SAP Platform / Supportive": "SAP"
    },
    "KRM": {
      "Kone Remote Monitoring": "KRM"
    }
  },
  "users": [
    {
      "username": "admin",
      "password": "admin123",
      "role": "admin"
    },
    {
      "username": "ops_engg",
      "password": "operator123",
      "role": "ops_engg"
    },
    {
      "username": "ops_spec",
      "password": "viewer123",
      "role": "ops_spec"
    }
  ]
};

export default config;
